/**
 * Shared Redux actions that are used across multiple slices
 *
 * These actions are extracted here to avoid circular dependencies between slices.
 */

import { createAction } from '@reduxjs/toolkit';
import { ResetPayload } from '../types/metaTypes';

/**
 * Reset Redux state action
 * Used by all slices to reset their state (e.g., on logout)
 */
export const resetRedux = createAction<ResetPayload>('app/resetRedux');
